export type FuelKind = "ELECTRICITY" | "GAS" | "DUAL"
export type MeterKind = "TRADITIONAL" | "SMETS1" | "SMETS2"
export type HealthVerdict = "OK" | "DRIFTED" | "FLAPPING" | "ERROR"

export const UNKNOWN = "UNKNOWN" as const
export type Unknown = typeof UNKNOWN

export interface ObservedAccountState {
  accountStatus: string | Unknown
  fuel: FuelKind | Unknown
  meterKind: MeterKind | Unknown
  hasActiveAgreement: boolean | Unknown
  insideRenewalWindow: boolean | Unknown
  multiMeterpoints: boolean | Unknown
  latestReadingDate: string | Unknown
}

export interface AccountStateSample {
  fetchedAt: string
  errors: string[]
  state: ObservedAccountState
}

export type ExpectedAccountState = Partial<{
  // A single string is an exact match; an array is a membership check - the
  // observed value must be one of the listed acceptable values.
  accountStatus: string | string[]
  fuel: FuelKind
  meterKind: MeterKind
  hasActiveAgreement: boolean
  insideRenewalWindow: boolean
  multiMeterpoints: boolean
}>

export interface MappedTest {
  spec: string
  rpProject: string
  rpNameFilter: string
}

export interface TestAccountMapEntry {
  accountNumber: string
  role: string
  expected: ExpectedAccountState
  tests: MappedTest[]
}

export interface AccountHealth {
  verdict: HealthVerdict
  driftedFields: string[]
  flappingFields: string[]
  errors: string[]
}

export interface AccountHealthRow {
  entry: TestAccountMapEntry
  samples: AccountStateSample[]
  health: AccountHealth
}
